export interface Product {
  request_id?: number;
  product_id?: number;
  product_name?: string;
  suggested_products?: StockCheckSuggestedProducts[];
  product_image_url?: string;
  quantity?: number;
  holding_period?: number;
  expected_raw_inward_timeline?: number;
  expected_print_inward_timeline?: number;
  in_stock?: number;
  vendor_name?: string;
  notes?: string | null;
  vendor_stock?: number;
  active?: number;
  created_date?: string;
  modified_date?: string;
  updated_suggested_products?: StockCheckSuggestedProducts[];
  stock_available_qty?: number;
  sourcing_notes?: string;
  cost_price?: number;
  vendor_id?: number;
}

export interface Stock {
  id?: number;
  order_id?: number;
  order_label?: string;
  order_type?: string;
  requestor_id?: number;
  requestor_name?: string;
  status?: number;
  closer_id?: number;
  closer_name?: string;
  closing_date?: string;
  expiry_date?: string;
  notes?: string;
  tat?: string;
  active?: number;
  created_date?: string;
  modified_date?: any;
  status_label?: string;
  products?: Product[];
  rejected_by?: string;
  rejection_reason?: string;
  min_products_timeline?: number;
  min_suggested_products_timeline?: number;
}

export enum StockCheckRequestStatus {
  OPEN = 1,
  CLOSED,
  REJECTED,
}

export const getStockCheckRequestStatusLabel = (
  stockCheck: StockCheckRequestStatus | null | undefined,
) => {
  if (stockCheck === null || stockCheck === undefined) {
    return "Pending";
  }

  if (stockCheck === StockCheckRequestStatus.OPEN) {
    return "Open";
  } else if (stockCheck === StockCheckRequestStatus.CLOSED) {
    return "Closed";
  } else if (stockCheck === StockCheckRequestStatus.REJECTED) {
    return "Rejected";
  }
};

export interface StockCheckSuggestedProducts {
  request_id: number;
  product_id?: number;
  suggested_prod_id?: number;
  id?: number;
  vendor_id?: number;
  timeline?: number;
  expected_raw_inward_timeline?: number;
  expected_print_inward_timeline?: number;
  quantity: number;
  vendor_stock?: number;
  product_name?: string;
  product_image_urls?: string[];
  vendor_name?: string;
  cost_price?: number;
  active?: number;
}

export interface DeleteSuggestedProductParams {
  requestId: number;
  productId: number;
  suggestedProductId: number;
}
